import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import PageHeader from "../../../components/PageHeader/PageHeader";
import DataCard from "../../../components/DataCard/DataCard";
import { dashboardReceptionContext } from "../../../context/ReceptionContext/DashboardReceptionContext/DashboardReceptionContext";
import { Block } from "../../../components/Block/Block";
import { Col, Row } from "../../../components/Grid/Grid";
import { convertRoleToPath } from "../../../utils";

import "chart.js/auto";

const DashboardReception = () => {
  const auth = useSelector((state) => state.auth);

  const { overview, handleGetOverview } = useContext(dashboardReceptionContext);

  useEffect(() => {
    handleGetOverview();
  }, []);

  const items = [
    { title: "تمامی تیکت ها", key: "allTickets", url: "tickets" },
    { title: "تیکت های باز", key: "openTickets", url: "tickets" },
    { title: "تراکنشات", key: "allTransactions", url: "transactions" },
  ];

  return (
    <>
      <SiteTitle title="داشبورد" />

      <PageHeader
        title="داشبورد"
        description="به پنل پذیرنده رفاهی تو خوش آمدید"
      />

      {!isEmpty(items) && (
        <Block className="mt-4">
          <Row className="g-gs">
            {items.map((item) => (
              <Col xxl="3" sm="6">
                <DataCard
                  title={item?.title}
                  amount={overview[item?.key]}
                  {...(item?.url && {
                    url: `/${convertRoleToPath(auth.role)}/${item?.url}`,
                  })}
                />
              </Col>
            ))}
          </Row>
        </Block>
      )}
    </>
  );
};

export default DashboardReception;
